import { Alert, Link, Snackbar, Typography } from '@mui/material'
import React, { useContext, useEffect } from 'react'
import { MainForm } from './MainForm'
import { deepPurple } from '@mui/material/colors'
import { Divider } from '../../Divider'
import { CustomContainer } from '../../components/CustomContainer'
import { AppContext } from '../../context/context'
import { useScrollToTop } from '../../hooks/useScrollTop'
import { initialDataState } from '../../App'

const version = process.env.REACT_APP_ENERSI_VERSION || "0.0.0"

export const MainPage = () => {
  useScrollToTop()
  const { data, setData } = useContext(AppContext)
  const { error, errorMessage } = data

  const handleClose = () => {
    setData({ ...data, error: false, errorMessage: '' })
  }

  useEffect(() => {
    setData(initialDataState)
  }, [])


  return (
    <CustomContainer>
      <Typography color="white" variant="body1" paragraph align="center" sx={{
        maxWidth: 560
      }}>
        Para un mejor servicio tienes el mes en curso de tu consumo para solicitar tu factura, dentro del mismo año en que se realizo tu consumo. Recuerda que la fecha de la factura corresponde al día que la generas.
      </Typography>
      <Divider />
      <MainForm />
      <Typography color="#fff" variant="caption" component="p" align="center">
        Si tienes problemas para facturar o tu forma de pago es incorrecta, da Click 
        <Link href='mailto:facturacion@unu.mx?subject=Soporte%20Gas%20UNU' style={{
        color: deepPurple[100],
        fontWeight: 900,
        cursor: 'pointer'
      }}> aqui</Link>
      <p>Version: {version}</p>
      </Typography>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={error}
        key="top right"
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert severity="error">{errorMessage}</Alert>
      </Snackbar>
    </CustomContainer>

  )
}
